import { FilledImageFieldImage } from '@prismicio/client'
import clsx from 'clsx'
import { buildURL } from 'imgix-url-builder'

import styles from './ResponsiveImage.module.css'

const VARIANTS = [640, 960, 1280, 1440, 1920, 2560]

type Props = {
	image: FilledImageFieldImage
	sizes?: string
	fill?: boolean
	cover?: boolean
	quality?: number
}

export class ResponsiveImage {
	constructor() {}

	static render({ image, sizes, fill, cover, quality = 80 }: Props) {
		const srcSet = VARIANTS.map((variant) => `${buildURL(image.url, { w: variant, q: quality })} ${variant}w`).join(
			', '
		)
		const aspect = image.dimensions.width / image.dimensions.height

		return /* HTML */ `<div
			class="${clsx(styles.Main, fill && styles.Fill, cover && styles.Cover)}"
			style="--aspect:${aspect};"
		>
			<img
				class="${styles.Img}"
				srcset="${srcSet}"
				sizes="${sizes ? sizes : '100vw'}"
				alt="${image.alt?.replaceAll('"', `'`)}"
				loading="lazy"
			/>
		</div>`
	}
}
